import map from 'lodash/map';

import { LaboratoryServiceData, LaboratoryServiceListQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export class LaboratoryServiceLongList extends LongList<
    LaboratoryServiceData,
    LaboratoryServiceData,
    LaboratoryServiceListQuery
> {
    public readonly limit: number = 50;

    public getLaboratoryServiceIds(): string[] {
        return map(this.values, 'serviceId');
    }

    protected create(params: LaboratoryServiceData): LaboratoryServiceData {
        return params;
    }
}
